export default class Placement
{
    public static readonly BTM:string = "bottom";
    public static readonly SYLLABLE:string = "syllable";
    public static readonly TOP:string = "top";
}